import React from 'react';
import {toAbsoluteUrl} from '../../../../../../_metronic/_helpers';
import {Button} from "react-bootstrap";
import * as actions from '../../../_redux/paymentsActions';
import can from "../../../../_common/components/Permissions/can";

export function DownloadPaymentConfirmColumnFormatter(cellContent, intl, dispatch) {
  const tooltip = intl.formatMessage({
    id: "automatedPayments-tooltip-downloadPayment",
    defaultMessage: "Download payment confirm",
  });
  const downloadPaymentConfirmFunc = (paymentRequestID) => () => {
    dispatch(actions.downloadPaymentConfirmAction(paymentRequestID));
  };

  return (
    <div className="font-size-sm d-flex align-items-center justify-content-center">
      <Button
        className={`btn btn-icon btn-light btn-sm mx-3 custom-action-button ${cellContent.fileEsists ? `` : `custom-disabled-button`}`}
        title={tooltip}
        onClick={downloadPaymentConfirmFunc({
          paymentRequestID: cellContent._id
        })}
        disabled={!(cellContent.fileEsists && can('full', 'bituahLeumiPayment'))}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Download_brandColor.svg')}
          alt="download"
        />
      </Button>
    </div>
  )
}
